import React, { useState, useEffect, useRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Modal } from "react-bootstrap";
import PropTypes from "prop-types";
import "react-time-picker/dist/TimePicker.css";
import "../../assets/css/modal.css";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import PopUp from "../Modals/Popup";
import { ButtonGroup, Dropdown } from "react-bootstrap";
import "../../assets/css/form.css"
import "./PickUpDate.css";
import ModalCloseButton from "../ModalCloseButton/ModalCloseButton";

import { FaRegCalendarAlt } from "react-icons/fa";
import { RiTimerLine } from "react-icons/ri";


const renderAddress = (props, order) => {
  if (props.method === 1) {
    if (props.address) {
      const address = props.address.full_address
      return address
    } else {
      return "Please select Address"
    }
  } else if (props.method === 2) {
    if (order.out_name) {
      return order.out_name
    } else if (localStorage.out_name) {
      return localStorage.out_name
    } else {
      return "Please select Outlet"
    }
  }
}

const PickupDate = (props) => {
  let order = props.order;

  let show = props.show;
  const [load, setLoad] = useState(false);
  const [popupText, setPopupText] = useState("");
  const [lshow, setLshow] = useState(false);

  const dateObj = new Date()
  const [date, setDate] = useState(new Date());
  const [timeRange, setRange] = useState(`Select your ${props.method === 1 ? "Delivery" : "Pickup"} Time`);
  const [currentOrder, setOrder] = useState(props.method);
  const [timeRangeDP, setTimeRangeDP] = useState([]);

  const [timePopup, setTimePopup] = useState(false);

  // Get today's date
  const today = new Date();

  const oneMonthLater = new Date();
  oneMonthLater.setMonth(oneMonthLater.getMonth() + 1);
console.log(props.business_location,'props.business_location')
  const isScheduleOrder=  props.business_location?.map(
    (location) => location.enable_scheduled_order
  );
  console.log("isScheduleOrder", isScheduleOrder);
  useEffect(() => {
    var d = new Date();
    var h = d.getHours();
    var m = d.getMinutes();

    var timeNow = parseFloat(h + '.' + m).toFixed(2);
    let outlet_id;
    var result = props.outlates?.business_location?.filter(obj => {
      outlet_id = props.order.out_id ? props.order.out_id : props.getCurrentOutlet.id;
      return obj.id === outlet_id;
    });

    if (result?.length > 0) {
      var collectTimeRange = [];
      
      // Helper function to convert "HH:MM" format to decimal (e.g., "09:30" -> 9.5)
      const timeStringToDecimal = (timeStr) => {
        if (!timeStr) return 0;
        const [hours, minutes] = timeStr.split(':').map(Number);
        return hours + (minutes / 60);
      };

      // Get open and close times from outlet
      const outlet = result[0];
      const openTimeDecimal = timeStringToDecimal(outlet.open_time);
      const closeTimeDecimal = timeStringToDecimal(outlet.close_time);

      console.log('Outlet open_time:', outlet.open_time, 'Decimal:', openTimeDecimal);
      console.log('Outlet close_time:', outlet.close_time, 'Decimal:', closeTimeDecimal);

      // Check if selected date is today
      const now = new Date();
      const selectedDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
      const todayDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      const isToday = selectedDate.getTime() === todayDate.getTime();

      console.log('Selected date is today:', isToday);

      // Generate time slots based on outlet open/close times
      for (let i = openTimeDecimal; i < closeTimeDecimal; i += 0.25) {
        let startEndTime = [i, i + 0.25];

        // For today: only show future time slots (after current time)
        // For future dates: show all time slots from opening time
        const shouldShow = isToday ? parseFloat(timeNow) < i : true;

        if (shouldShow) {
          startEndTime.forEach(function (se, seIndex) {
            if (se > closeTimeDecimal) {
              se = closeTimeDecimal;
            }

            let hours = Math.floor(se);
            let minutes = Math.round((se - hours) * 60);

            let ampm = hours >= 12 ? "PM" : "AM";
            if (hours > 12) hours -= 12;
            if (hours === 0) hours = 12;

            let minutesStr = minutes.toString().padStart(2, "0");
            startEndTime[seIndex] = `${hours}:${minutesStr} ${ampm}`;
          });

          collectTimeRange.push(startEndTime[0] + " - " + startEndTime[1]);
        }
      }

      setTimeRangeDP(collectTimeRange);

      if (collectTimeRange?.length > 0 && !order?.time) {
        setRange(collectTimeRange[0]);
      }
    }
  }, [props, order, date])

  useEffect(() => {
    if (
      !props.loading &&
      props.norders &&
      props.norders !== null &&
      props.norders.success &&
      load
    ) {
      setLoad(false);
    }
  }, [props.outlates?.business_location, order, load]);

  const checkTime = (selectedTime, selectedDate = null) => {
    // pre_order_time in minutes
    let pre_order_time = Number(props.business_location?.[0]?.pre_order_time) || 30;
    let startTimeStr = selectedTime?.split(" - ")?.[0];
    if (!startTimeStr) return true;
    let now = new Date();

    // If a selectedDate is provided, build the slot start using that date.
    // Otherwise use today's date.
    let baseDate;
    if (selectedDate) {
      baseDate = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate());
    } else {
      baseDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    }

    let slotStart = new Date(`${baseDate.toDateString()} ${startTimeStr}`);

    let cutoff = new Date(slotStart.getTime() - pre_order_time * 60 * 1000);

    let cutoffStr = cutoff.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit"
    });

    if (now >= cutoff) {
      setPopupText(`Not available for this slot. You needed to order before ${cutoffStr}`);
      setLshow(true);
      return false;
    }
    return true;
  };

  const changeDate = (date) => {
    setDate(date);
    let oldOrder = { ...order };
    oldOrder["date"] = date.toDateString();
    try {
      const now = new Date();
      const selectedDay = new Date(date.getFullYear(), date.getMonth(), date.getDate());
      const todayDay = new Date(now.getFullYear(), now.getMonth(), now.getDate());

      if (selectedDay > todayDay) {
        let timeToUse = oldOrder.time || timeRange || "";
        let scheduled_at = null;

        if (timeToUse && !timeToUse.toLowerCase().includes("select your")) {
          const startPart = timeToUse.split(" - ")[0].trim();
          const composed = new Date(`${date.toDateString()} ${startPart}`);
          const yyyy = composed.getFullYear();
          const mm = String(composed.getMonth() + 1).padStart(2, "0");
          const dd = String(composed.getDate()).padStart(2, "0");
          const hh = String(composed.getHours()).padStart(2, "0");
          const min = String(composed.getMinutes()).padStart(2, "0");
          scheduled_at = `${yyyy}-${mm}-${dd} ${hh}:${min}:00`;
        } else {
          const yyyy = date.getFullYear();
          const mm = String(date.getMonth() + 1).padStart(2, "0");
          const dd = String(date.getDate()).padStart(2, "0");
          scheduled_at = `${yyyy}-${mm}-${dd} 00:00:00`;
        }

        oldOrder["scheduledOrder"] = {
          scheduled_at: scheduled_at,
          type: "schedule",
        };
      } else {
        if (oldOrder["scheduledOrder"]) delete oldOrder["scheduledOrder"];
      }
    } catch (e) {
      console.error("Error computing scheduledOrder:", e);
    }

    props.setOrder(oldOrder);

    const offset = date.getTimezoneOffset();
    date = new Date(date.getTime() - (offset * 60 * 1000));
    date = date.toISOString().split('T')[0];
  }

  const changeTime = (time) => {
    const isValid = checkTime(time, date);
    if (!isValid) {
      return;
    }

    let oldOrder = { ...order };

    if (time != "Select your Pickup Time") {
      setRange(time);
      oldOrder["time"] = time;

      // Update scheduledOrder with the correct scheduled_at timestamp
      const now = new Date();
      const selectedDay = new Date(date.getFullYear(), date.getMonth(), date.getDate());
      const todayDay = new Date(now.getFullYear(), now.getMonth(), now.getDate());

      if (selectedDay > todayDay) {
        const startPart = time.split(" - ")[0].trim();
        const composed = new Date(`${date.toDateString()} ${startPart}`);
        const yyyy = composed.getFullYear();
        const mm = String(composed.getMonth() + 1).padStart(2, "0");
        const dd = String(composed.getDate()).padStart(2, "0");
        const hh = String(composed.getHours()).padStart(2, "0");
        const min = String(composed.getMinutes()).padStart(2, "0");
        const scheduled_at = `${yyyy}-${mm}-${dd} ${hh}:${min}:00`;

        oldOrder["scheduledOrder"] = {
          scheduled_at: scheduled_at,
          type: "schedule",
        };
      }
    }

    props.setOrder(oldOrder);
  }

  const ProceedOrder = () => {
    let oldData = { ...order };
    const isValid = checkTime(timeRange, date);
    if (!isValid) {
      return;
    }

    // Use freshly selected values OR previously stored ones
    const hasDate = oldData["date"] || date;
    const effectiveTime = (timeRange && !timeRange.toLowerCase().includes("select")) ? timeRange : oldData["time"];
    const hasTime = !!effectiveTime;

    if (hasDate && hasTime) {
      // Persist if not already saved
      if (date && oldData["date"] !== date.toDateString()) {
        changeDate(date);
      }
      if (effectiveTime && oldData["time"] !== effectiveTime) {
        changeTime(effectiveTime);
      }

      if (props.method === 2) {
        if (localStorage.date) {
          localStorage.removeItem("date");
        }
        localStorage.setItem("date", (date || new Date()).toLocaleDateString("en-US"));
        oldData["order_type"] = 2;
        props.setShowPayment(true);
      }
      props.closeModal();
    } else {
      setPopupText("Select Date and Time!");
      setLshow(true);
    }
  };

  if (currentOrder !== props.method) {
    setOrder(props.method)
    setRange(`Select your ${props.method === 1 ? "Delivery" : "Pickup"} Time`)
  }

  return (
    <Modal
      show={show}
      onHide={props.closeModal}
      dialogClassName="modal-md modal-dialog-scrollable modern-modal"
      centered
      size="sm"
    >
      <PopUp
        text={popupText}
        show={lshow}
        closeModal={() => setLshow(false)}
      />
      <Modal.Header>
        <Modal.Title>
          {props.method === 1 ? "Your delivery time" : "Pick up"}
        </Modal.Title>
        <ModalCloseButton
          onClick={props.closeModal}
          style={{ position: 'static', width: '32px', height: '32px' }}
        />
      </Modal.Header>
      <Modal.Body>
        <div
          style={{
            filter: timePopup ? "blur(4px)" : "none",
            pointerEvents: timePopup ? "none" : "auto",
            userSelect: timePopup ? "none" : "auto",
            transition: "filter 0.3s ease-in-out",
          }}
        >
          <div className="form-group-custom">
            <label className="label-custom">
              {props.method === 1 ? "Selected address" : "Selected outlet"}
            </label>
            <div className="display-value-box">
              {renderAddress(props, order)}
            </div>
          </div>

          <div className="form-group-custom">
            <label className="label-custom">
              Select your {props.method === 1 ? 'delivery' : 'pick up'} date
            </label>

            <div className="input-with-icon">
              <FaRegCalendarAlt className="input-icon" />
              <DatePicker
                minDate={today}
                maxDate={isScheduleOrder == 1 ? oneMonthLater : today}
                className="form-control-custom"
                selected={date}
                onChange={changeDate}
                dateFormat="dd/MM/yyyy"
                showPopperArrow={false}
                popperClassName="datepicker-relative-popup"
                popperPlacement="bottom-start"
              />
            </div>
          </div>

          <div className="form-group-custom">
            <label className="label-custom">
              Select your {props.method === 1 ? 'delivery' : 'pick up'} time
            </label>

            <button
              className="time-select-trigger"
              onClick={() => setTimePopup(true)}
            >
              <RiTimerLine className="input-icon" />
              <span>{timeRange || "Select Time"}</span>
            </button>

            <Modal
              show={timePopup}
              onHide={() => setTimePopup(false)}
              centered
              dialogClassName="time-popup-dialog"
            >
              <Modal.Header>
                <Modal.Title>Select Time</Modal.Title>
                <ModalCloseButton
                  onClick={() => setTimePopup(false)}
                  style={{ position: 'static', width: '32px', height: '32px' }}
                />
              </Modal.Header>

              <Modal.Body>
                <div className="time-grid">
                  {timeRangeDP.map((time, idx) => (
                    <button
                      key={idx}
                      className="time-slot-btn"
                      onClick={() => {
                        changeTime(time);
                        setRange(time);
                        setTimePopup(false);
                      }}
                    >
                      {time}
                    </button>
                  ))}
                </div>
              </Modal.Body>
            </Modal>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn-proceed-modern" onClick={ProceedOrder}>
          Proceed
        </button>
      </Modal.Footer>
    </Modal>
  );
};

PickupDate.propTypes = {
  closeModal: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  outlates: state?.products?.outlates,
  norders: state?.products?.order,
  loading: state?.products?.loading,
  business_location: state?.products?.business_location,
  getCurrentOutlet: state?.products?.getCurrentOutlet
});
export default withTranslation()(connect(mapStateToProps, {})(PickupDate));